import { atom } from 'recoil'
import { selectorWithoutCache as selector } from 'util/RecoilWithoutCache'
import { IsolatedInfoConfig } from 'api/spot'

// !!!支持的保证金，用户当前使用的保证金，及其模式在这里

/**
 * 模拟当前使用的保证金币种
 */
const CurrentMarginState = atom<string>({
    key: 'current-margin-state',
    default: ''
})

/**
 * 注意：获取当前保证金选择，如果没有，默认支持保证金的第一个
 */
export const CurrentMarginSelector = selector<string>({
    key: 'base-current-margin-selector',
    get: ({ get }) => {
        return get(CurrentMarginState)
    },
    set: ({ set }, tokenId) => {
        set(CurrentMarginState, tokenId)
    }
})

